import { useMemo } from 'react';
import './hoursBoxClients.css';
import {
  determinePriceByDate,
  minsInSpan,
  minsInSpanEdited,
  hoursInSpan,
} from '../utils/hoursUtils';

export const HoursBoxClients = (props) => {

  const dateRangeLabel = useMemo(() => {
    if (!props.currentStartDate || !props.currentEndDate) return '';
    const trueEnd = new Date(props.currentEndDate);
    trueEnd.setDate(trueEnd.getDate() - 1);
    return `${props.currentStartDate} - ${trueEnd.getMonth()+1}/${trueEnd.getDate()}/${trueEnd.getFullYear()}`;
  }, [props.currentStartDate, props.currentEndDate]);

  const rows = useMemo(() => {
    return props.clientList.map(clientName => {
      const shiftsInSpan = props.eventList.filter(event => {
        const scheduledStart = (event.editedStartTime && event.originalStartTime)
          ? new Date(event.originalStartTime)
          : new Date(event.start);
        return (
          scheduledStart > new Date(props.currentStartDate) &&
          scheduledStart < new Date(props.currentEndDate) &&
          event.client === clientName.name
        );
      });

      const scheduledHours = hoursInSpan(minsInSpan(shiftsInSpan, { excludeCleaning: false, useOriginalIfEdited: false }));
      const actualHours    = hoursInSpan(minsInSpanEdited(shiftsInSpan, { excludeCleaning: false }));
      const rate           = determinePriceByDate(clientName.rate, new Date(props.currentEndDate).getTime());
      const subtotal       = (rate * actualHours).toFixed(2);
      const misc           = shiftsInSpan.reduce((sum, s) => {
        if (!s.isFlatFee) return sum;
        return sum + (s.flatFeeAmountClient == null ? 0 : Number(s.flatFeeAmountClient));
      }, 0);
      const total          = (rate * actualHours + misc).toFixed(2);

      return { name: clientName.name, scheduledHours, actualHours, rate, subtotal, misc: misc.toFixed(2), total };
    });
  }, [props.clientList, props.eventList, props.currentStartDate, props.currentEndDate]);

  return (
    <div className="HoursBoxClientsDiv" id="hoursBoxClientsDiv">
      <a name="hoursBoxTargetClient" />
      <h2 id="hoursHeaderClient">Client Hours</h2>
      <h3 id="currentWeekHeaderHoursClients">{dateRangeLabel}</h3>
      <table id="clientTable">
        <thead>
          <tr>
            <td className="hoursBoxClientsLabel">Name</td>
            <td className="hoursBoxClientsLabel">Scheduled Hours</td>
            <td className="hoursBoxClientsLabel">Actual Hours</td>
            <td className="hoursBoxClientsLabel">Rate</td>
            <td className="hoursBoxClientsLabel">Hourly Subtotal</td>
            <td className="hoursBoxClientsLabel">Flat Rates</td>
            <td className="hoursBoxClientsLabel">Total</td>
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr key={row.name}>
              <td>{row.name}</td>
              <td>{row.scheduledHours}</td>
              <td>{row.actualHours}</td>
              <td>${row.rate}</td>
              <td>${row.subtotal}</td>
              <td>${row.misc}</td>
              <td>${row.total}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
